import React from "react";

const TextileMillProductIcon = ({ color = "#5D5D5D", size = 35 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Mirror */}
      <ellipse
        cx="11"
        cy="12"
        rx="6"
        ry="8"
        stroke={color}
        strokeWidth="1.8"
      />
      <path
        d="M11 20V26"
        stroke={color}
        strokeWidth="1.8"
        strokeLinecap="round"
      />

      {/* Comb Spine */}
      <path
        d="M24 11C25.2 11 26 11.8 26 13V21C26 22.2 25.2 23 24 23"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* 6 evenly spaced comb teeth */}
      <path d="M24 12L20 12" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M24 14.5L20 14.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M24 17L20 17" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M24 19.5L20 19.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M24 22L20 22" stroke={color} strokeWidth="2" strokeLinecap="round" />
      <path d="M24 24.5L20 24.5" stroke={color} strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

export default TextileMillProductIcon;
